module.exports = __webpack_public_path__ + "img/img_seg1.f6952905.png";